<h1 mat-dialog-title>PDF Vorschau</h1>

<div mat-dialog-content style="overflow: hidden !important; padding: 6px !important">
    <kiene-pdf-viewer-component [pdfViewerInput]="pdfViewerInput"></kiene-pdf-viewer-component>
</div>
<div mat-dialog-actions>
    <button mat-flat-button color="accent" (click)="dialogRef.close()">Schlie&szlig;en</button>
</div>
